import React, { useState } from "react";
import { FcHome, FcInvite, FcPhone } from "react-icons/fc";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "regenerator-runtime/runtime";
import { db } from "../data/firebase";
import { collection, addDoc } from "firebase/firestore";
import { sendMessage } from "../actions/messageActions";
const Contacts = () => {
  //
  const [sent, setSent] = useState(false);
  const [data, setData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // saveMessage(data);
    setSent(true);
    // if (data.fName === "" || data.email === "" || data.message === "") {
    //   toast.error("Please fill up provided spaces.");
    //   return;
    // }
    // try {
    //   await addDoc(collection(db, "requests"), data);

    //   toast.success("Message sent successfully!");
    //   setSent(false);
    // } catch (e) {
    //   console.error("Error adding document: ", e);
    //   toast.error("Message failed");
    //   setSent(false);
    // }
    const messageData = {
      fullName: data.fullName,
      email: data.email,
      message: data.message,
      status: "Unread",
    };

    const response = await sendMessage(messageData);
    if (response.param === "success") {
      toast.success(response.msg);
      setSent(false);
    } else {
      toast.error("Something went wrong!");
      setSent(false);
    }
  };
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  return (
    <>
      <ToastContainer autoClose={3000} />
      <div className="title-container">
        <h2 className="title">Contacts</h2>
        <div className="contact-container">
          <h1>Wanna build something?</h1>
          <div className="message">
            <form action="" onSubmit={handleSubmit}>
              <label htmlFor="fName">Full Name</label>
              <input
                type="text"
                name="fullName"
                autoComplete="off"
                id="fullName"
                onChange={handleChange}
              />
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                autoComplete="off"
                id="email"
                onChange={handleChange}
              />
              <label htmlFor="">More information</label>
              <textarea
                name="message"
                id=""
                autoComplete="off"
                width="100%"
                maxLength="100"
                onChange={handleChange}
                placeholder="Must have at least 100 characters"
              ></textarea>
              <button type="submit">
                {sent ? "Please wait" : "Submit Request"}
              </button>
            </form>
            <div className="personal-contact">
              <div className="info">
                <FcInvite className="icon" />
                <div className="content">
                  <p>jadedar6@gmail.com</p>
                  <p>Send me an email</p>
                </div>
              </div>
              <div className="info">
                <div>
                  <FcPhone className="icon" />
                </div>
                <div className="content">
                  <p>09302500149</p>
                  <p>Monday - Sunday</p>
                </div>
              </div>
              <div className="info">
                <FcHome className="icon" />
                <div className="content">
                  <p>Leyte, Philippines</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacts;
